var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support"},[_c('b-skeleton',{staticClass:"image-wrapper",attrs:{"animation":"wave"}}),_c('b-skeleton',{staticClass:"content-wrapper",attrs:{"animation":"wave"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }